<template>
    <div class="OrderRefund fSize">
        <van-cell-group>
            <van-cell>
                <van-row>
                    <van-col span="8">套餐名称：</van-col>
                    <van-col span="16">{{data.name}}</van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="8">订单编号：</van-col>
                    <van-col span="16">{{data.buyOrderCode}}</van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="8">订单金额：</van-col>
                    <van-col span="16">{{'￥'+(data.buyMoney/100)}}</van-col>
                </van-row>
            </van-cell>
            <van-cell>
                <van-row>
                    <van-col span="8">下单时间：</van-col>
                    <van-col span="16">{{data.createTime}}</van-col>
                </van-row>
            </van-cell>
        </van-cell-group>
        <div style="margin: 0.18rem">
            <van-button safe-area-inset-bottom size="normal" round block type="info" plain hairline
                        @click="submitFun" :loading="loading" loading-text="申请中...">确认退款
            </van-button>
        </div>
    </div>
</template>
<script>
    import {Dialog, Cell, CellGroup, Button, Toast, Row, Col} from 'vant';
    import {refundOrder} from '@/api/order';

    export default {
        name: "OrderRefund",
        props: {
            item: {type: String, default: ""}
        },
        components: {
            [Dialog.name]: Dialog,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Button.name]: Button,
            [Toast.name]: Toast,
            [Row.name]: Row,
            [Col.name]: Col
        },
        data() {
            return {
                data: [],
                //按钮样式
                loading: false
            }
        },
        watch: {
            //正确给 cData 赋值的 方法
            item: function (newVal, oldVal) {
                newVal && this.drawChart(newVal); //newVal存在的话执行drawChar函数
            }
        },
        created() {
            const that = this;
            that.drawChart(that.item);
            console.log(that.data)
        },
        methods: {
            //数据处理
            drawChart(newVal) {
                const that = this;
                that.loading = false;
                that.data = JSON.parse(newVal);
            },
            //退款按钮
            submitFun() {
                const that = this;
                that.loading = true;
                let ip = JSON.parse(localStorage.getItem("localCs"));
                let obj = {
                    //组装退款参数
                    o: sessionStorage.getItem("openid"),
                    b: that.data.buyOrderCode,
                    ip: ip.cip
                };
                refundOrder(obj).then(resp => {
                    that.loading = false;
                    if (resp.code === 200) {
                        Dialog.alert({
                            message: '退款成功！',
                        }).then(() => {
                            that.data = {};
                            //关闭购买框
                            that.$emit('fatherMethod');
                        });
                    } else {//订单创建失败
                        Toast.fail(resp.msg);
                    }
                }).catch(err => {
                    console.log(err)
                })
            }
        }
    }
</script>
<style scoped>
    .OrderRefund {
        min-height: 4rem;
    }
</style>
